export const getters = {
  getSecretarias({ compromissos }) {
    const secretarias = new Map();

    compromissos.forEach(element => {
      secretarias.set(element.unidade_executora, {
        sigla: element.unidade_executora,
        nome: element.nome_unidade_executora
      });
    });

    const sortedSecretarias = Array.from(secretarias.values()).sort((a, b) => {
      return a.nome.localeCompare(b.nome);
    });

    return sortedSecretarias;
  },
  getTotalCompromissosPorSecretaria({ compromissos }) {
    const reducer = (acum, compr) => {
      const sigla = compr.unidade_executora;
      const nome = compr.nome_unidade_executora;

      if (!acum[sigla]) {
        acum[sigla] = {
          nome: nome,
          total: 0
        };
      }

      acum[sigla].total++;

      return acum;
    };

    const totaisPorSecretaria = compromissos.reduce(reducer, {});
    const sortedObject = Object.entries(totaisPorSecretaria).sort((a, b) => b[1].total - a[1].total);

    return sortedObject.map(([sigla, dados]) => ({
      sigla: sigla,
      nome: dados.nome,
      total: dados.total
    }));
  },
  getTotalCompromissosPorStatus({ compromissos }) {
    const reducer = (acum, compr) => {
      const status = compr.status;

      if (!acum[status]) {
        acum[status] = 0;
      }

      acum[status]++;

      return acum;
    };

    const totaisPorStatus = compromissos.reduce(reducer, {});
    const sortedObject = Object.entries(totaisPorStatus).sort((a, b) => b[1] - a[1]);

    return sortedObject.map(([status, total]) => ({
      status: status,
      total: total
    }));
  },
  getSecretariasComResumo({ compromissos }) {
    const unidades = {};

    compromissos.forEach(compr => {
      const sigla = compr.unidade_executora;

      if (!unidades[sigla]) {
        unidades[sigla] = {
          sigla: sigla,
          nome: compr.nome_unidade_executora,
          total: 0,
          concluido: 0,
          emAndamento: 0,
          naoIniciado: 0,
          cancelado: 0,
          percentual: 0
        };
      }

      unidades[sigla].total++;
      if (compr.status === 'Concluído') unidades[sigla].concluido++;
      if (compr.status === 'Em andamento') unidades[sigla].emAndamento++;
      if (compr.status === 'Não Iniciado') unidades[sigla].naoIniciado++;
      if (compr.status === 'Cancelado') unidades[sigla].cancelado++;
    });

    const arrayUnidades = Object.values(unidades);

    arrayUnidades.forEach(unidade => {
      const total = unidade.total - unidade.cancelado;

      if (total > 0) {
        unidade.percentual = Math.round((unidade.concluido / total) * 100);
      }
    });

    return arrayUnidades.sort((a, b) => a.nome.localeCompare(b.nome));
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/plano_governo/getters.js